jQuery(document).ready(function($){

  if($('.m-staff-slider')[0]){
    $('.m-staff-slider__wrapper').slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: true,
        dots: false,
        infinite: true,
        adaptiveHeight: true,
        nextArrow: $('.m-staff-slider__button-next'),
        prevArrow: $('.m-staff-slider__button-prev'),
    });
  }
  });